// src/services/authService.js
import axios from 'axios';

// const API = 'https://expertb.codebyte.live/api/auth'; // ✅ Updated to match backend route
const API='https://expertb.codebyte.live/api/auth'
export const signupAdmin = async (data) => {
  return axios.post(`${API}/signup`, data);
};

export const loginAdmin = async (data) => {
  return axios.post(`${API}/login`, data);
};
